<div class="userprofile-container ya-typography">
  <ya-subheader [hasContent]="true">
  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset">
    <h2 class="header-title" langkey="phUserProfileAddress_MainAddress_Title">
    </h2>
    <div class="ya-tab-content-wrapper user-address-content-wrapper">
      <div class="ya-form-control-container">
        <ya-dynamicFormFields #dynamicFormFieldsComponent
          *ngIf="billingInfoInputsViewModel && billingInfoInputsViewModel.length>0 && userAddressViewModel"
          [customerFieldsConfig]="billingInfoInputsViewModel" [initialData]="getUserInfoInitialData()">
        </ya-dynamicFormFields>
      </div>
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-webshop-button-container">
            <ng-container *ngIf="isOnline && isDynamicFormGroupValid(); then activeButton else deactiveButton">
            </ng-container>
            <ng-template #activeButton>
              <button mat-flat-button (click)="saveUserInfo()"><span
                  langkey="phUserProfileAddress_Save_User_Info"></span></button>
            </ng-template>
            <ng-template #deactiveButton>
              <span (click)="markAllFieldsAsTouched()">
                <button mat-flat-button disabled><span langkey="phUserProfileAddress_Save_User_Info"></span></button>
              </span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>